import { render, staticRenderFns } from "./checkbox-quarternary.vue?vue&type=template&id=0229bab6&scoped=true&"
import script from "./checkbox-quarternary.vue?vue&type=script&lang=js&"
export * from "./checkbox-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229bab6",
  null
  
)

export default component.exports